export const MAX_PROGRESS_ENTRIES = 30;

export const PROGRESS_MESSAGES = {
  SYNCING:
    'The tutorial progress will be synced to your user settings. You can close the tab or browser and reopen this tutorial later to continue from where you left off.',
  SYNCED:
    'The tutorial has been synced from your user settings. You can now continue from where you left off last time.',
  COMPLETED:
    'You have completed this tutorial once. You may start from the beginning.',
} as const;
